import { CustomTableCell, CustomTableHead, FormSectionHeader, Loader, NoData } from "@/components";
import { Button, Card, CardContent, Table, TableBody, TableHeader, TableRow } from "@/components/ui";
import useManualEntry from "./useManualEntry";
import { Trash2 } from "lucide-react";
import { cn, formatAmount } from "@/lib/utils";
import { isFieldSkipped } from "./consts";
import { FormProvider } from "react-hook-form";

const ManualEntry = ({configFields, isLoading}: {configFields: any, isLoading?: boolean}) => {
  console.log("🚀 ~ ManualEntry ~ configFields:", configFields)
  const {form, renderDynamicField, 
    headerFields, lineItemRows, 
    lineItemFields, removeRow, 
    addRow, onSubmit, balanceAmount, 
    isAddPending,
    isSubmitPending,
    onSubmitForApproval} = useManualEntry({configFields});

  return (
    <div className="flex flex-col gap-5 relative w-full max-w-full overflow-hidden">
      <div className="flex lg:items-end lg:justify-end lg:absolute lg:-top-10 lg:right-0">
        Balance Amount: 
        <span
          className={cn(
            balanceAmount == 0 ? "text-green-600" : "text-red-600",
            "ml-2"
          )}
        >
          {formatAmount(balanceAmount, 2)}
        </span>
      </div>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-5">
            <Card className="rounded-md">
              <CardContent>
                <FormSectionHeader>Document Header</FormSectionHeader>
                {isLoading ? <Loader /> : 
                  headerFields?.length ?
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                      {headerFields?.map((field: any) => {
                        if (isFieldSkipped(field.fieldName)) return <></>
                        return renderDynamicField(field, form)
                      })}
                    </div> :
                    <NoData />
                }
              </CardContent>
            </Card>
            <Card className="p-0 overflow-hidden">
              <CardContent className="px-0 !py-4 overflow-hidden">
                <div className="flex flex-row items-center justify-between pb-4">
                  <FormSectionHeader className="px-6" wrapperClassName="mb-0">Line Items</FormSectionHeader>
                  {isLoading ? <></> : headerFields?.length ? <Button variant="link" onClick={addRow} type="button">+ Add Line Item</Button> : <></>}
                </div>
                {isLoading ? <Loader /> : 
                  lineItemRows?.length ? 
                    <div className="overflow-x-auto w-full block clear-both">
                      <Table className="min-w-max w-full table-auto">
                        <TableHeader>
                          <TableRow className="mb-3 rounded">
                            {lineItemFields.map((field: any) => {
                              if (isFieldSkipped(field.fieldName)) return <></>
                              return (
                                <CustomTableHead key={field.fieldName} className={cn(field.fieldName == "delete" ? "w-[80px]" : 'w-[250px]')}>
                                  {field.displayLabel}
                                </CustomTableHead>
                              )
                            })}
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {lineItemRows.map((_, index) => (
                            <TableRow>
                              {lineItemFields.map((field: any) => {
                                if (isFieldSkipped(field.fieldName)) return <></>
                                return (
                                  <CustomTableCell key={field.fieldName} className="pb-7">
                                    {field?.fieldName == "delete" ? 
                                      <Trash2 className="stroke-red-600 h-5 w-5" onClick={() => removeRow(index)} /> :
                                      renderDynamicField(field, form, index)}
                                  </CustomTableCell>
                                )
                                })}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div> :
                    <NoData />
                }
              </CardContent>
            </Card>

            {headerFields?.length && lineItemRows?.length ? 
              <div className="flex flex-end justify-end gap-3">
                <Button type="submit" disabled={balanceAmount != 0 || isAddPending}>{isAddPending ? <Loader variant="secondary" /> : <></>} Park</Button>
                {configFields?.[0]?.documentType == "VI" ? 
                  <Button type="submit" disabled={balanceAmount != 0 || isSubmitPending} onClick={onSubmitForApproval}>{isSubmitPending ? <Loader variant="secondary" /> : <></>} Submit for Approval</Button> : <></>
                }
              </div> : <></>}
          </div>
        </form>
      </FormProvider>
    </div>
  )
}

export default ManualEntry;